import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-800 text-white p-4 text-center">
      <p>&copy; 2024 VIP Company. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
